import React, { useCallback, useEffect, useState } from "react";
import api from "../api";
import bgVideo from "../assets/lbg.mp4";

export default function TenantAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchAnnouncements = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const res = await api.get("/announcements");
      setAnnouncements(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setError("Unable to load announcements.");
      setAnnouncements([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAnnouncements();
  }, [fetchAnnouncements]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 font-sans">
      <video data-workspace-background="true" aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        src={bgVideo}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="absolute inset-0 bg-slate-950/86"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/95 to-teal-950/80"></div>

      <div className="workspace-page-body relative z-10 min-h-screen px-4 py-16 text-white sm:px-6 md:py-10 lg:px-8">
        <div className="mb-6 flex flex-col gap-4 border-b border-white/10 pb-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.35em] text-teal-300">
              Tenant Updates
            </p>
            <h1 className="mt-2 text-3xl font-bold tracking-wide md:text-4xl">
              Announcements
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-300 md:text-base">
              Read the latest updates and notices from property management.
            </p>
          </div>

          <div className="rounded-lg border border-white/10 bg-white/5 px-5 py-3 text-center">
            <p className="text-2xl font-bold text-teal-200">
              {announcements.length}
            </p>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
              Published
            </p>
          </div>
        </div>

        {loading ? (
          <div className="rounded-lg border border-white/10 bg-slate-950/90 py-10 text-center text-slate-300">
            Loading announcements...
          </div>
        ) : error ? (
          <div className="rounded-lg border border-red-300/30 bg-red-500/15 py-10 text-center text-red-100">
            {error}
          </div>
        ) : announcements.length === 0 ? (
          <div className="rounded-lg border border-dashed border-white/15 bg-slate-950/70 px-4 py-10 text-center text-slate-300">
            No announcements have been published yet.
          </div>
        ) : (
          <div className="grid gap-4">
            {announcements.map((announcement) => (
              <article
                key={announcement.id}
                className="rounded-lg border border-white/10 bg-slate-950/90 p-5 shadow-2xl"
              >
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                  <div>
                    <h2 className="text-2xl font-bold text-white">
                      {announcement.title}
                    </h2>
                    <p className="mt-2 text-sm text-slate-400">
                      {announcement.published_at
                        ? new Date(announcement.published_at).toLocaleString()
                        : new Date(announcement.created_at).toLocaleString()}
                    </p>
                  </div>
                  <span className="w-fit rounded-full border border-teal-300/40 bg-teal-500/15 px-3 py-1 text-xs font-semibold text-teal-200">
                    Published
                  </span>
                </div>
                <p className="mt-4 whitespace-pre-wrap rounded-lg bg-white/5 p-4 text-sm leading-6 text-slate-300">
                  {announcement.message}
                </p>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
